import {
    map,
    pluck,
    filter,
    switchMap,
    distinctUntilChanged,
    bufferCount,
} from 'rxjs/operators';
import { combineLatest } from 'rxjs';

import createTimer from './createTimer';
import interval$ from '../../../Shared/Streams/interval';

const BUFFER_COUNT = 3;

const createWatchedEvent = (
    tokenUpdate$,
    userActionsUpdate$,
    assetUpdate$,
    player,
) =>
    combineLatest(
        tokenUpdate$,
        assetUpdate$,
        userActionsUpdate$,
    )
        .pipe(
            switchMap(([
                latestToken,
                latestAsset,
                latestUserActions,
            ]) => {
                const playbackStatus$ = player.state.stores.playback.update$
                    .pipe(
                        pluck('playbackStatus'),
                        distinctUntilChanged(),
                    );
                const start$ = playbackStatus$
                    .pipe(
                        filter(value => value === 'PLAYING'),
                    );

                const pause$ = playbackStatus$
                    .pipe(
                        filter(value => (
                            value === 'PAUSED' ||
                            value === 'BUFFERING'
                        )),
                    );

                const stop$ = playbackStatus$
                    .pipe(
                        filter(value => value === 'UNLOADED'),
                    );

                const maxDurationInSeconds = latestUserActions.watched[latestAsset.type];

                const maptoWatchedEvent = () => ({
                    token: latestToken,
                    assetId: latestAsset.assetId,
                    duration: maxDurationInSeconds,
                    type: latestAsset.type,
                });

                return createTimer(
                    start$,
                    pause$,
                    stop$,
                    interval$.pipe(bufferCount(BUFFER_COUNT)),
                    maxDurationInSeconds,
                )
                    .pipe(
                        map(maptoWatchedEvent),
                    );
            })
        );

export default createWatchedEvent;
